module.exports = __webpack_public_path__ + "files/c4303cbec8a632537d071698b8c2c0ad.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people_body-4.png
// module id = 501
// module chunks = 76